import React, { ReactNode } from 'react'

type CardTitleProps ={
  title:string | number | ReactNode;
}

export default function CardTitle({title}:CardTitleProps) {
  return (
    <div className="text-black font-normal text-[1.25rem] mr-1">{title}</div>
  )
}
